import React from 'react';
import Alert from '../../Shared/components/Alert';
import SearchPage from './SearchPage';
const Search = ({ viewType, token }) => {
    switch (viewType) {
        case 'searchandresult':
            return React.createElement(SearchPage, { token: token });
        default:
            return React.createElement(Alert, null);
    }
};
// Set focus to input field when menu is opened
document.addEventListener('zdsNavigationBodyOpened', function (event) {
    if (event.detail.identifier === 'search-body') {
        document
            .querySelector('zds-input-search')
            .shadowRoot.querySelector('zds-input-text')
            .shadowRoot.querySelector('input')
            .focus();
    }
});
export default Search;
